import { zInt, zMonetary } from 'core/infrastructure-next';
import { z } from 'zod';

export const denominationSchema = z.object({
	value: zMonetary({ nonNegative: true }),
	count: zInt({ nonNegative: true }).nullable()
});

export type Denomination = z.infer<typeof denominationSchema>;

export const denominationCountSchema = z.object({
	coins: z.array(denominationSchema),
	bills: z.array(denominationSchema),
	other: zMonetary({ nonNegative: true })
		.nullable()
});

export type DenominationCount = z.infer<typeof denominationCountSchema>;

export const denominationValues = [0.01, 0.02, 0.05, 0.10, 0.20, 0.50, 1.00, 2.00, 5.00, 10.00, 20.00, 50.00, 100.00, 200.00, 500.00];

export function editCount(state: DenominationCount, value: number, count: Nullable<number>): DenominationCount {
	return {
		...state,
		bills: state.bills.map(d => d.value === value ? { value, count } : d),
		coins: state.coins.map(d => d.value === value ? { value, count } : d)
	};
}

export function editOther(state: DenominationCount, count: Nullable<number>): DenominationCount {
	return {
		...state,
		other: count
	};
}

export function zero(): DenominationCount {
	return {
		coins: denominationValues.filter(x => x < 5).map((val) => ({
			value: val,
			count: 0,
		})),
		bills: denominationValues.filter(x => x >= 5).map((val) => ({
			value: val,
			count: 0,
		})),
		other: 0,
	};
}

export function total(count: DenominationCount): number {
	const cents = count.coins.concat(count.bills).sum(x => (x.count ?? 0) * x.value);
	return (count.other ?? 0) + cents;
}
